import React, { Fragment, useState } from "react";
import { Col, Row, Container } from "react-bootstrap";
import classesX from "../Dashboard/dashboard.module.css";
import AdminNavbar from "../navbar/adminNavbar";
import classes from "../WebsiteManagement/websiteManagement.module.css";
import FlightBookings from "./flightBookings";
import BusBookings from "./busBookings";
import TrainBookings from "./trainBookings";
import HotelBookings from "./hotelBookings";
import OtpList from "./otpList";
    
const ServiceManagement = () => {
  const [active, setActive] = useState("1");
  const tabs = [
    { id: "1", label: "OTP Management" },
    { id: "2", label: "Train Management" },
    { id: "3", label: "Bus Management" },
    { id: "4", label: "Flights Management" },
    { id: "5", label: "Hotel Management" },
  ];

  return (
    <Fragment>
      <AdminNavbar />
      <h1 className={classesX.Heading}>Service Management</h1>
      <Container fluid style={{ paddingLeft: 10 }}>
        <Row>
          <Col lg={12} className={classes.Response2}>
            <ul style={{ display: "flex", listStyle: "none", padding: 0, marginBottom: 0 }}>
              {tabs.map((tab) => (
                <li
                  key={tab.id}
                  onClick={() => setActive(tab.id)}
                  style={{
                    flex: 1,
                    textAlign: "center",
                    padding: "12px 0",
                    cursor: "pointer",
                    color: "#fff",
                    backgroundColor: active === tab.id ? "steelblue" : "#585858",
                  }}
                >
                  {tab.label}
                </li>
              ))}
            </ul>
          </Col>
          <Col lg={12} className={classes.Response} style={{ margin: "2vh 3vw" }}>
            {active === "1" ? (
              <OtpList />
            ) : active === "2" ? (
              <TrainBookings />
            ) : active === "3" ? (
              <BusBookings />
            ) : active === "4" ? (
              <FlightBookings />
            ) : (
              <HotelBookings />
            )}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ServiceManagement;
